import thumbnail from './thumbnail.svg'
import icon from './icon.svg'

export const metadata = {
    id: 'rawgraphs.spiral',
    name: 'Spiral Chart',
    description:
        'A Spiral Chart (or Polar Line Chart) visualizes time-series data in a polar coordinate system, useful for showing cyclical patterns over time.',
    categories: ['time series'],
    thumbnail,
    icon,
    code: '',
    tutorial: '',
}
